import type React from 'react';

function NorceIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="100%" height="100%" viewBox="0 0 188.6 188.6" {...props}>
      <title>NorceIcon</title>

      <g id="Lager_1-2" data-name="Lager 1">
        <g>
          <path
            d="M2.3,41.49H108.42v105.48h-22.78V65.38H25.5v81.63H2.3V41.49Z"
            fill="currentColor"
          />
          <path
            d="M186.08,128.06v23.58c-18.81-.41-34.52-6.9-45.51-22.09-14.17-19.6-15.56-41.02-4.86-62.49,10-20.06,27.52-28.96,50.56-30.09,0,7.52,.16,14.7-.2,21.86-.05,.92-2.69,2.24-4.27,2.47-16.21,2.44-25.93,13.28-27.28,30.72-1.29,16.64,7.57,30.22,22.67,34.51,2.63,.75,5.42,.95,8.89,1.53Z"
            fill="currentColor"
          />
        </g>
        <rect width="188.6" height="188.6" fill="none" />
      </g>
    </svg>
  );
}

export default NorceIcon;
